module.exports = __webpack_public_path__ + "img/phones-lg.9953f1a7.png";